<template>
    <div class="row">
        <div v-for="edge in edges" class="col-lg-4 mb-5 mb-md-0">
            <label class="font-weight-bold">
                {{ edge.name }}
            </label>
            <PackageEdgeInput v-model="dimensions[edge.key]"/>
            <FormErrors
                :error="formErrors[`dimensions.${edge.key}.value`]"/>
            <FormErrors
                :error="formErrors[`dimensions.${edge.key}.unit`]"/>
        </div>
    </div>
</template>

<script>
import FormErrors from "@components/Form/FormErrors.vue";
import PackageEdgeInput from "@components/Packages/PackageEdgeInput.vue";

export default {
    components: {PackageEdgeInput, FormErrors},

    props: {
        formErrors: {
            type: Object,
            default() {
                return {}
            }
        },
        value: Object
    },

    data() {
        return {
            edges: [
                {key: 'width', name: __('general.width')},
                {key: 'height', name: __('general.height')},
                {key: 'length', name: __('general.length')},
            ],
            dimensions: this.value || {
                width: {
                    value: 0.0,
                    unit: this.getDefaultUnit()
                },
                height: {
                    value: 0.0,
                    unit: this.getDefaultUnit()
                },
                length: {
                    value: 0.0,
                    unit: this.getDefaultUnit()
                }
            }
        }
    },

    methods: {
        getDefaultUnit() {
            if (this.$page.props.user.selected_language === 'en') {
                return 'in';
            }

            return 'cm';
        }
    },

    watch: {
        dimensions: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
